export const sanitizeHtmlTitle = title => {
  if (!title) return ""
  return title.replace(/<(?!\/?strong\b)[^>]*>/gi, "")
}

export const sanitizeHtmlTitleForSEO = title => {
  if (!title) return ""
  return title.replace(/<[^>]*>/g, "")
}

export const removeInlineStyles = html => {
  if (!html) return ""
  return html.replace(/\s*style\s*=\s*["'][^"']*["']/gi, "")
}

export const parseSignals = signalsString => {
  if (!signalsString) return []

  const cleanText = signalsString.replace(/<[^>]*>/g, "").trim()
  if (!cleanText) return []

  return cleanText
    .split(",")
    .map(signal => signal.trim())
    .filter(Boolean)
    .map(signal => ({
      title: signal,
      value: "",
    }))
}

export const buildChallengeCards = post =>
  Array.from({ length: 3 }, (_, index) => {
    const cardIndex = index + 1
    const title = post[`chal_card_title_${cardIndex}`]
    const text = post[`chal_card_text_${cardIndex}`]

    if (!title && !text) {
      return null
    }

    return {
      title: sanitizeHtmlTitle(title),
      text: removeInlineStyles(text),
      key: `challenge-card-${cardIndex}`,
    }
  }).filter(Boolean)

export const buildMetrics = post => {
  const metrics = []

  for (let i = 1; i <= 4; i += 1) {
    const label = post[`metric_label_${i}`]
    const value = post[`metric_value_${i}`]

    if (!label || !value) {
      continue
    }

    let cleanValue = value
    let arrowDirection = null

    if (value.startsWith("+")) {
      cleanValue = value.substring(1).trim()
      arrowDirection = "up"
    } else if (value.startsWith("-")) {
      cleanValue = value.substring(1).trim()
      arrowDirection = "down"
    }

    metrics.push({ label, value: cleanValue, arrowDirection, index: i })
  }

  return metrics
}
